import * as yup from 'yup';

export const leistungsumfangSchema = yup
  .object({
    leitungswasser: yup.boolean().required().default(true),
    elementar: yup.boolean().required().default(false),
    sturmHagel: yup.boolean().required().default(true),
    glasversicherung: yup.boolean().required().default(false),
    feuerBlitz: yup.boolean().required().default(true),
  })
  .test({
    name: 'isRequired',
    message:
      'Bitte wählen Sie mindestens eines der drei Felder Leitungswasser, Sturm & Hagel oder Feuer & Blitzschlag aus.',
    test(value) {
      return value.leitungswasser || value.sturmHagel || value.feuerBlitz;
    },
  });
